export enum DomainAuthStatus {
    Verified = 'verified',
    NotVerified = 'not-verified',
    Failed = 'failed',
}
